import React, { Component } from 'react';
import moment from 'moment';
import Axios from 'axios';
import firebase from 'firebase/app';
import 'firebase/database';
import styled from 'styled-components';
import { CSVLink } from 'react-csv';
import deburr from 'lodash/deburr';
import flatten from 'lodash/flatten';
import isEmpty from 'lodash/isEmpty';
import orderBy from 'lodash/orderBy';
import isNull from 'lodash/isNull';
import isEqual from 'lodash/isEqual';
import getPath from 'lodash/get';
import setPath from 'lodash/set';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import InfiniteScroll from 'react-infinite-scroller';

// TODO start migrating to latest material ui, for now new components can co-exist with older.
// https://material-ui.com/guides/migration-v0x/
import Colors from '../../../../styles/colors';
import {
  NoAccess,
  BaseButton,
  RowDivision,
  LoadingWrapper,
  Select,
} from '../../../../styles/styled';
import Loading from '../../../../components/Loading';
import commonStyles from '../../../../styles/commonStyles';
import {
  getSoundcastsManagedv2,
  getUsageCurrent,
  getUsageLimit,
  canUserAccessFeature,
} from '../../../../helpers/userinfoHelper';
import { getSoundcastSubscribers } from '../../../../helpers/soundcasts';
import InviteSubscribersModal from './InviteSubscribersModal';
import PendingInvitesModal from './PendingInvitesModal';
import EmailListModal from './EmailListModal';
import RegisteredOnButton from './RegisteredOnButton';
import CustomDialog from '../custom_dialog';
import { ALERTS } from '../../../../helpers/texts';
import { publisherManager, userManager } from '../../../../helpers/managers';
const {
  isSoundcastDripped,
  isOneTimeBillingCycle,
} = require('../../../../../server/scripts/utils.js')();

const PAGINATED_SUBSCRIBERS_LIMIT = 100;

function matchEmail(emails, phraseForComparison) {
  if (typeof emails != 'undefined') {
    emails = flatten(emails);
    for (var i = 0; i < emails.length; i++) {
      const email = emails[i] ? emails[i].toLowerCase() : '';
      if (email.includes(phraseForComparison)) {
        return true;
      }
    }
  }
  return false;
}

class Subscribers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentSoundcastID: null,
      currentSoundcast: { invited: {}, title: '' },
      soundcasts_managed: [],
      subscribersAll: [],
      subscribersFiltered: [],
      subscribers: [],
      toBeUnsubscribed: [],
      checked: false,
      showModal: false,
      showPendingInvite: false,
      showEmailList: false,
      allowed: false,
      hasMailChimp: false,
      loader: true,
      updater: false,
      findPhrase: '',
      findDebounceTimer: null,
    };

    this.retrieveSubscriberInfo = this.retrieveSubscriberInfo.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.deleteSubscriber = this.deleteSubscriber.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.handlePendingInvite = this.handlePendingInvite.bind(this);
    this.onMountOrReceiveProps = this.onMountOrReceiveProps.bind(this);
    this.retrieveSubscribers = this.retrieveSubscribers.bind(this);
    this.retrieveSubscribersBySoundcastId = this.retrieveSubscribersBySoundcastId.bind(this);
    this.handleEmailList = this.handleEmailList.bind(this);
  }

  componentDidMount() {
    setTimeout(() => {
      this.onMountOrReceiveProps(this.props);
    }, 500);
  }

  componentWillReceiveProps(nextProps) {
    this.onMountOrReceiveProps(nextProps);
  }

  onMountOrReceiveProps(props) {
    const { userInfo } = props;
    this.setState({ allowed: canUserAccessFeature('VIEW_SUBSCRIBERS') }, async () => {
      const soundcastsManaged = getSoundcastsManagedv2();
      if (!isEmpty(soundcastsManaged) && userInfo.publisher) {
        // set mailChimp, we need to get the latest data
        const { id: publisherId, mailChimp: oMailChimp = {} } = userInfo.publisher;
        const mailChimp = !isEmpty(oMailChimp)
          ? await publisherManager.getProp(publisherId, 'mailChimp')
          : false;
        this.setState(
          { hasMailChimp: !isEmpty(mailChimp), soundcasts_managed: soundcastsManaged },
          () => {
            if (isEmpty(this.state.currentSoundcastID)) {
              // retrieve subscribers of the first managed soundcast
              this.retrieveSubscribers(soundcastsManaged[0]);
            }
          }
        );
      }
    });
  }

  handleModal() {
    const { showModal, currentSoundcast } = this.state;
    if (!showModal) {
      const { published = false, landingPage = true } = currentSoundcast;
      if (!published) {
        return this.alertDialog.showModal({
          content: 'Please publish your soundcast first before inviting listeners.',
        });
      }
    }

    this.setState({ showModal: !showModal });
  }

  handlePendingInvite() {
    this.setState({ showPendingInvite: !this.state.showPendingInvite });
  }

  async retrieveSubscribers(currentSoundcast) {
    const subscribers = await getSoundcastSubscribers(currentSoundcast);

    // verify each subscribers if they were a subscriber of the soundcast
    const filteredSubscribers = subscribers.filter(user => {
      const { soundcasts: userSoundcasts = {} } = user;
      return currentSoundcast.id in userSoundcasts;
    });

    // sort subscribers by date
    const sortedSubscribers = orderBy(
      filteredSubscribers,
      user => {
        const { soundcasts: userSoundcasts = {} } = user;
        return userSoundcasts[currentSoundcast.id].date_subscribed;
      },
      'desc'
    );

    const subscribersAll = [...sortedSubscribers];
    const subscribersFiltered = this.takeSubscribersByPhrase(subscribersAll, this.state.findPhrase);
    const subscribersRender = this.takeFirstPageSubscribers(subscribersFiltered);

    this.setState({
      currentSoundcastID: currentSoundcast.id,
      currentSoundcast: currentSoundcast,
      subscribersAll,
      subscribersFiltered,
      subscribers: subscribersRender,
      loader: false,
      updater: false,
    });
  }

  retrieveSubscribersBySoundcastId(currentSoundcastID) {
    const { soundcasts_managed } = this.state;
    const selectedSoundcast = soundcasts_managed.find(soundcast => {
      return soundcast.id === currentSoundcastID;
    });

    this.setState(
      {
        currentSoundcastID,
        subscribersAll: [],
        subscribersFiltered: [],
        subscribers: [],
        toBeUnsubscribed: [],
        updater: true,
      },
      () => this.retrieveSubscribers(selectedSoundcast)
    );
  }

  handleEmailList() {
    this.setState({ showEmailList: !this.state.showEmailList });
  }

  retrieveSubscriberInfo(userId) {
    return firebase
      .database()
      .ref('users/' + userId)
      .once('value')
      .then(snapshot => {
        // that.subscribers.push({...JSON.parse(JSON.stringify(snapshot.val())), id: userId});
        return { ...JSON.parse(JSON.stringify(snapshot.val())), id: userId };
      })
      .then(
        res => res,
        err => console.log(err)
      );
  }

  handleCheck(e) {
    this.setState({ checked: e.target.checked });
    const id = e.target.name.split('-')[0];
    const toBeUnsubscribed = this.state.toBeUnsubscribed.slice(0);
    if (e.target.checked) {
      toBeUnsubscribed.push(id);
    } else {
      const position = toBeUnsubscribed.indexOf(id);
      if (position > -1) {
        toBeUnsubscribed.splice(position, 1);
      }
    }
    // console.log('toBeUnsubscribed: ', toBeUnsubscribed);
    this.setState({ toBeUnsubscribed });
  }

  async deleteSubscriber() {
    const {
      currentSoundcastID,
      currentSoundcast,
      toBeUnsubscribed,
      subscribers: oldSubscribers,
      subscribersAll: oldSubscribersAll,
      findPhrase,
    } = this.state;
    const { userInfo } = this.props;
    const publisherID = userInfo.publisherID;

    let privateSubscribersCount = 0;

    const isPrivate = currentSoundcast.published && !currentSoundcast.landingPage;
    if (isPrivate && canUserAccessFeature('SOUNDCAST_PRIVATE')) {
      const limit = getUsageLimit('ALLOWED_SOUNDCAST_PRIVATE_SUBSCRIBERS');
      if (limit && limit < Number.MAX_VALUE) {
        privateSubscribersCount = getUsageCurrent('private_subscribers');
      }
    }

    if (toBeUnsubscribed.length === 0) {
      return confirm(`Please select the listeners to unsubscribe`);
    }

    if (
      confirm(
        `Are you sure you want to unsubscribe these listeners from ${this.state.currentSoundcast.title}? There is no going back!`
      )
    ) {
      // remove all to be unsubscribe listeners
      Promise.all(
        toBeUnsubscribed.map(userId => {
          return new Promise(async resolve => {
            try {
              await Axios.post('/api/unsubscribe', {
                userId,
                soundcastId: currentSoundcastID,
                publisherId: publisherID,
              });

              if (privateSubscribersCount > 0) {
                privateSubscribersCount--;
                this.props.decreasePlanCurrentUsage({ type: 'private_subscribers' });
              }
            } catch (err) {
              console.log(`Failed to unsubscribe user with id ${userId}`, err.message);
            } finally {
              if (currentSoundcast.subscriberEmailList) {
                // delete email from email list
                const theUser = oldSubscribers.find(subscriber => subscriber.id === userId);
                await Axios.post('/api/delete_emails', {
                  emails: theUser.email,
                  emailListId: currentSoundcast.subscriberEmailList,
                });
              }

              resolve();
            }
          });
        })
      );

      // order and remove the listener from the subscribers list
      const subscribersAll = orderBy(
        oldSubscribersAll,
        ({ soundcasts = {} }) => soundcasts[currentSoundcastID].date_subscribed,
        'desc'
      ).filter(subscriber => !toBeUnsubscribed.includes(subscriber.id));

      const subscribersFiltered = this.takeSubscribersByPhrase(subscribersAll, findPhrase);
      const subscribers = this.takeFirstPageSubscribers(subscribersFiltered);

      // set to state
      this.setState({
        subscribersAll,
        subscribersFiltered,
        subscribers,
        checked: false,
        currentSoundcast,
        currentSoundcastID,
        toBeUnsubscribed: [],
      });
    }
  }

  getSubscriptionStatus(subscription) {
    const {
      subscription_ended = null,
      billingCycle: billingCycleRaw = '',
      trial_end = null,
      current_period_end = null,
      date_subscribed = null,
      iap = false, // TODO: iap subscription not contains billingCycle and date_subscribed
    } = subscription;
    const billingCycle = (billingCycleRaw || '').toLowerCase();

    const isFreeBC = isEmpty(billingCycle) || isEqual(billingCycle, 'free');
    if (isFreeBC || isOneTimeBillingCycle(billingCycle)) {
      if ((isFreeBC || isEqual(billingCycle, 'rental'))
        && !isNull(current_period_end) && !isNull(date_subscribed)
        && (current_period_end > date_subscribed)
      ) {
        const rentalDays = moment.unix(current_period_end).diff(moment.unix(date_subscribed), 'days') - 1;
        if (rentalDays < 35770) { // 365 * 98
          return <SubStatus className="label label-info">RENTAL {rentalDays} D</SubStatus>;
        }
      }
    } else {
      if (!isNull(subscription_ended) && subscription_ended === true) {
        return <SubStatus className="label label-default">NOT RENEWED</SubStatus>;
      }
  
      if (!isNull(trial_end)) {
        return <SubStatus className="label label-warning">TRIAL</SubStatus>;
      }
    }

    return <SubStatus className="label label-success">CURRENT</SubStatus>;
  }

  takeSubscribersByPhrase = (subscribersToFind = [], findPhrase = null) => {
    if (!findPhrase) {
      // console.log(`phrase [] --> subscribers.length ${subscribersToFind.length}`);
      return subscribersToFind;
    }

    const checkValue = deburr(findPhrase.trim()).toLowerCase();
    const subscribers = subscribersToFind.filter(subscriber => {
      const fullName = deburr(
        `${(subscriber.firstName || '').trim()} ${(subscriber.lastName || '' ).trim()}`.trim()
      ).toLowerCase();
      return fullName.includes(checkValue) || matchEmail(subscriber.email, checkValue);
    });

    // console.log(`phrase [${checkValue}] subscribers.length ${subscribers.length}`);
    return subscribers;
  };

  takeFirstPageSubscribers = subscribers => {
    return subscribers.length <= PAGINATED_SUBSCRIBERS_LIMIT
      ? subscribers.slice(0)
      : subscribers.slice(0, PAGINATED_SUBSCRIBERS_LIMIT);
  };

  findSubscribersByPhrase = () => {
    const findDebounceTimer = setTimeout(() => {
      const { subscribersAll = [], findPhrase } = this.state;

      const subscribersFiltered = this.takeSubscribersByPhrase(subscribersAll, findPhrase);
      const subscribers = this.takeFirstPageSubscribers(subscribersFiltered);

      this.setState({
        subscribers,
        subscribersFiltered,
        toBeUnsubscribed: [],
        updater: false,
      });
    }, 1000);

    this.setState({
      findDebounceTimer,
    });
  };

  findSubscribersDebounced = () => {
    if (this.state.updater) {
      if (this.state.findDebounceTimer) {
        clearTimeout(this.state.findDebounceTimer);
      }
      this.findSubscribersByPhrase();
      return;
    }

    this.setState(
      {
        updater: true,
      },
      this.findSubscribersByPhrase
    );
  };

  onFindInputStateChange() {
    return e => {
      const findPhrase = e.target.value;

      this.setState({
        findPhrase,
      }, () => {
        this.findSubscribersDebounced();
      });
    };
  }

  onFindClrButtonClicked() {
    return () => {
      if (this.state.findPhrase) {
        this.setState(
          {
            findPhrase: '',
            updater: true,
          },
          this.findSubscribersByPhrase
        );
      }
    };
  }

  renderFindInput = () => {
    return (
      <div>
        <input
          type="text"
          style={styles.findTerm}
          placeholder="Search listeners"
          onChange={this.onFindInputStateChange()}
          value={this.state.findPhrase}
        />
        <button style={styles.findClrButton} onClick={this.onFindClrButtonClicked()}>
          clr
        </button>
        <button type="submit" style={styles.findOkButton}>
          <i className="fa fa-search" />
        </button>
      </div>
    );
  };

  loadMorePaginatedSubscribers(page = 1) {
    try {
      const { subscribers: oldSubscribers = [], subscribersFiltered = [] } = this.state;

      const limit = oldSubscribers.length + PAGINATED_SUBSCRIBERS_LIMIT;
      const subscribers =
        subscribersFiltered.length > limit
          ? subscribersFiltered.slice(0, limit)
          : subscribersFiltered;

      this.setState({
        subscribers,
      });
    } catch (err) {
      console.log('Error retrieving subscribers', err.message);
    }
  }

  hasMorePaginatedSubscribers() {
    const { loader, updater, subscribers = [], subscribersFiltered = [] } = this.state;

    if (loader || updater) {
      return false;
    }

    return subscribersFiltered.length > subscribers.length;
  }

  render() {
    const {
      soundcasts_managed,
      subscribers,
      currentSoundcast,
      currentSoundcastID,
      allowed,
      hasMailChimp,
      findPhrase,
      subscribersFiltered,
      subscribersAll,
    } = this.state;
    const { history } = this.props;

    if (this.state.loader) {
      return (
        <RowDivision className="row">
          <LoadingWrapper height="90">
            <Loading text="Loading listeners, please wait" />
          </LoadingWrapper>
        </RowDivision>
      );
    }

    if (isEmpty(soundcasts_managed)) {
      return (
        <RowDivision className="row">
          <LoadingWrapper height="90">
            <Loading text="Verifying user, please wait" />
          </LoadingWrapper>
        </RowDivision>
      );
    }

    if (!allowed) {
      return (
        <NoAccess>
          <div className="upgrade padding-five sm-padding-ten sm-width-90 xs-width-100 bg-white">
            <div className="title-medium sm-title-medium xs-title-medium font-weight-600 margin-five-bottom">
              Upgrade to view subscribers
            </div>
            <div className="text-large sm-text-large line-height-26 margin-five-bottom">
              {ALERTS().VIEW_SUBSCRIBERS.NO_ACCESS}
            </div>
            <BaseButton onClick={() => history.push('/pricing')}>UPGRADE</BaseButton>
          </div>
        </NoAccess>
      );
    }

    const csvData = [['First Name', 'Last Name', 'Email']];
    const tmpSubscribers = isEmpty(findPhrase) ? subscribersAll : subscribersFiltered;
    tmpSubscribers.forEach(subscriber => {
      if (subscriber.email && subscriber.email[0]) {
        csvData.push([subscriber.firstName, subscriber.lastName, subscriber.email[0]]);
      }
    });
    const csvFileName = `${currentSoundcast.title} listeners${
      isEmpty(findPhrase) ? '' : ' filtered'
    }.csv`;

    return (
      <MuiThemeProvider>
        <React.Fragment>
          <InviteSubscribersModal
            isShown={this.state.showModal}
            soundcast={this.state.currentSoundcast}
            onClose={this.handleModal}
            userInfo={this.props.userInfo}
            onIncreasePrivateSubscribers={() => {
              this.props.increasePlanCurrentUsage({ type: 'private_subscribers' });
            }}
            onEndInviteListeners={() => {
              this.retrieveSubscribersBySoundcastId(this.state.currentSoundcastID);
            }}
          />
          <PendingInvitesModal
            isShown={this.state.showPendingInvite}
            soundcast={this.state.currentSoundcast}
            userInfo={this.props.userInfo}
            onClose={this.handlePendingInvite}
            onRemoveInvites={this.props.removeSoundcastPendingInvites}
          />
          {hasMailChimp && (
            <EmailListModal
              isShown={this.state.showEmailList}
              currentSoundcastID={this.state.currentSoundcastID}
              userInfo={this.props.userInfo}
              onClose={this.handleEmailList}
              soundcasts={soundcasts_managed}
            />
          )}
          <CustomDialog ref={ref => (this.alertDialog = ref)} />
          <div>
            <div className="padding-bottom-20px padding-top-20px">
              <div className="row">
                <div className="col-md-2 col-sm-4 col-xs-12">
                  <span className="title-medium ">Listeners</span>
                </div>
                <div className="col-md-6 col-sm-8 col-xs-12" style={styles.soundcastSelectWrapper}>
                  <Select
                    style={styles.soundcastSelect}
                    value={currentSoundcastID || ''}
                    onChange={e => {
                      this.retrieveSubscribersBySoundcastId(e.target.value);
                    }}>
                    {soundcasts_managed.map((souncast, i) => {
                      return (
                        <option style={styles.option} value={souncast.id} key={i}>
                          {souncast.title}
                        </option>
                      );
                    })}
                  </Select>
                </div>
                <div className="col-md-4 col-sm-12 col-xs-12" style={styles.searchWrap}>
                  {this.renderFindInput()}
                </div>
              </div>
            </div>
            <div className="row center-col">
              <div
                className={
                  hasMailChimp
                    ? `col-md-offset-1 col-md-2 col-sm-6 col-xs-12`
                    : `col-md-3 col-sm-6 col-xs-12`
                }
                style={styles.button}>
                <span style={{ color: Colors.mainOrange }} onClick={this.handleModal}>
                  Grant Access
                </span>
              </div>
              <div
                className={
                  hasMailChimp ? `col-md-2 col-sm-6 col-xs-12` : `col-md-3 col-sm-6 col-xs-12`
                }
                style={styles.button}>
                <span style={{ color: '#4DD0E1' }} onClick={this.handlePendingInvite}>
                  Pending Access Invites
                </span>
              </div>
              <div
                className={
                  hasMailChimp ? `col-md-2 col-sm-6 col-xs-12` : `col-md-3 col-sm-6 col-xs-12`
                }
                style={styles.button}>
                <CSVLink data={csvData} filename={csvFileName}>
                  <span>Download Listeners</span>
                </CSVLink>
              </div>
              {hasMailChimp && (
                <div className="col-md-2 col-sm-6 col-xs-12" style={styles.button}>
                  <span style={{ color: Colors.link }} onClick={this.handleEmailList}>
                    Connect Email List
                  </span>
                </div>
              )}
              <div
                className={
                  hasMailChimp ? `col-md-2 col-sm-6 col-xs-12` : `col-md-3 col-sm-6 col-xs-12`
                }>
                <div
                  style={{
                    ...styles.button,
                    color: this.state.toBeUnsubscribed.length > 0 ? 'red' : Colors.fontDarkGrey,
                  }}
                  onClick={this.deleteSubscriber}>
                  Unsubscribe
                </div>
              </div>
            </div>
            <div>
              <div
                className="col-md-12 col-sm-12 col-xs-12 table-responsive"
                style={styles.tableWrapper}>
                {this.state.updater && (
                  <RowDivision className="row">
                    <LoadingWrapper height="50">
                      <Loading text="Updating, please wait..." />
                    </LoadingWrapper>
                  </RowDivision>
                )}
                {!this.state.updater &&
                  this.state.findPhrase &&
                  this.state.subscribers.length === 0 && (
                    <RowDivision className="row">
                      <LoadingWrapper height="50">
                        <div className="title-medium sm-title-medium xs-title-medium font-weight-600">
                          <span style={{ color: '#F44336' }}>
                            There is no data that satisfies the condition!
                          </span>
                        </div>
                      </LoadingWrapper>
                    </RowDivision>
                  )}
                {!this.state.updater &&
                  !(this.state.findPhrase && this.state.subscribers.length === 0) && (
                    <InfiniteScroll
                      pageStart={1}
                      initialLoad={false}
                      loadMore={page => {
                        this.loadMorePaginatedSubscribers(page);
                      }}
                      hasMore={this.hasMorePaginatedSubscribers()}
                      loader={
                        <LoadingItemsWrapper key={0}>
                          <Loading align="center" text="Loading more items..." />
                        </LoadingItemsWrapper>
                      }
                      useWindow={false}
                      threshold={150}>
                      <table className="table table-condensed">
                        <thead>
                          <tr key={`${currentSoundcastID}`} style={styles.tr}>
                            <th style={{ ...styles.th }} />
                            <th style={{ ...styles.th }}>NAME</th>
                            <th style={{ ...styles.th }}>EMAIL</th>
                            <th style={{ ...styles.th }}>STATUS</th>
                            <th style={{ ...styles.th }}>REGISTERED ON</th>
                            <th style={{ ...styles.th }}>STATS</th>
                            <th style={{ ...styles.th }} />
                          </tr>
                        </thead>
                        <tbody>
                          {subscribers.map((subscriber, i) => {
                            if (!subscriber.email) {
                              return null;
                            }

                            const subscription = getPath(
                              subscriber.soundcasts,
                              currentSoundcastID,
                              {}
                            );
                            const {
                              subscription_ended = null,
                              date_subscribed = false,
                            } = subscription;
                            const subscriptionDate = !!date_subscribed
                              ? moment.unix(date_subscribed).format('YYYY-MM-DD')
                              : '__';
                            const isSubscriptionEnded =
                              !isNull(subscription_ended) && subscription_ended === true;

                            const enableRegisteredOnChange = !!date_subscribed
                              && !isEmpty(currentSoundcastID) && isSoundcastDripped(currentSoundcast)
                              && !isEmpty(subscriber.id) && !isEmpty(subscription);

                            const saveSelectedDate = async ({ unixDate, revertBak = false }) => {
                              try {
                                if (isNull(unixDate)) {
                                  throw new Error(`Bad ${JSON.stringify(unixDate)} date.`);  
                                }

                                const isSaveBak = revertBak || !('date_subscribed_bak' in subscription);
                                if (isSaveBak) {
                                  const bakUnixDate = revertBak ? null : date_subscribed;
                                  const bakValuePath = `soundcasts/${currentSoundcastID}/date_subscribed_bak`;
                                  await userManager.saveProp(subscriber.id, bakValuePath, bakUnixDate);
                                  setPath(subscriber, bakValuePath.replace(/\//g, '.'), bakUnixDate);
                                }
                                const valuePath = `soundcasts/${currentSoundcastID}/date_subscribed`;
                                await userManager.saveProp(subscriber.id, valuePath, unixDate);
                                setPath(subscriber, valuePath.replace(/\//g, '.'), unixDate);

                                // update listener delivery schedules
                                if (isSoundcastDripped(currentSoundcast)) {
                                  await Axios.post(
                                    `/api/soundcast/${currentSoundcastID}/episodes/delivery_update`,
                                    { userId: subscriber.id },
                                  );
                                } else {
                                  await new Promise(resolve => setTimeout(resolve, 1000));
                                }

                                // this.alertDialog.showModal({
                                //   title: 'INFO',
                                //   content: `Saved date ${moment.unix(unixDate).format('YYYY-MM-DD HH:mm')}`,
                                // });
                                return true;
                              } catch (err) {
                                this.alertDialog.showModal({
                                  title: 'ERROR',
                                  content: [
                                    'Picked date not saved.',
                                    <br key={`err-br-${subscriber.id}-${i}`} />,
                                    err.message
                                  ],
                                });
                                return false;
                              }
                            };

                            return (
                              <tr key={`${subscriber.id}-${i}`} style={styles.tr}>
                                <td style={{ ...styles.td }} />
                                <td
                                  style={{
                                    ...styles.td,
                                  }}>{`${subscriber.firstName} ${subscriber.lastName}`}</td>
                                <td style={{ ...styles.td }}>
                                  <a
                                    style={{ color: 'blue', textDecoration: 'underline' }}
                                    href={`mailto:${subscriber.email[0]}`}>
                                    {subscriber.email[0]}
                                  </a>
                                </td>
                                <td style={{ ...styles.td }}>
                                  {this.getSubscriptionStatus(subscription)}
                                </td>
                                <td style={{ ...styles.td }}>
                                  {/* {subscriptionDate} */}
                                  {!enableRegisteredOnChange && subscriptionDate}
                                  {enableRegisteredOnChange && (
                                    <RegisteredOnButton
                                      subscription={subscription}
                                      onSaveSelected={saveSelectedDate}
                                    />
                                  )}
                                </td>
                                <td style={{ ...styles.td }}>
                                  <span
                                    onClick={() => {
                                      history.push({
                                        pathname: `/dashboard/subscriber/${subscriber.id}`,
                                        state: {
                                          subscriber,
                                          soundcast: currentSoundcast,
                                        },
                                      });
                                    }}>
                                    <i className="far fa-chart-bar" style={styles.itemChartIcon} />
                                  </span>
                                </td>
                                <td style={{ ...styles.td }}>
                                  <input
                                    type="checkbox"
                                    id={`${subscriber.id}-${currentSoundcastID}`}
                                    value={`${subscriber.id}-${currentSoundcastID}`}
                                    name={`${subscriber.id}-${currentSoundcastID}`}
                                    onClick={this.handleCheck}
                                    style={styles.itemCheckbox}
                                    disabled={isSubscriptionEnded}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </InfiniteScroll>
                  )}
              </div>
            </div>
          </div>
        </React.Fragment>
      </MuiThemeProvider>
    );
  }
}

const LoadingItemsWrapper = styled.div`
  width: 100%;
`;

const SubStatus = styled.span`
  font-size: 70%;
`;

const commonFindButton = {
  position: 'absolute',
  right: '-0px',
  // width: '40px',
  height: '35px',
  border: '1px solid',
  borderColor: Colors.link,
  background: Colors.link,
  textAlign: 'center',
  color: '#fff',
  borderRadius: '5px',
  cursor: 'pointer',
  // marginTop: '2px',
  fontSize: '20px',
};

const styles = {
  tableWrapper: { ...commonStyles.tableWrapper, height: 550 },
  soundcastSelectWrapper: {
    height: 40,
    // width: 300,
    // backgroundColor: Colors.mainWhite,
    marginTop: 0,
    // marginLeft: 30,
    // marginRight: 30,
    // display: 'inline-block'
  },
  soundcastSelect: {
    backgroundColor: Colors.mainWhite,
    width: 'calc(100% - 20px)',
    height: 40,
    marginLeft: 10,
    marginRight: 10,
    marginTop: 0,
    fontSize: 16,
  },
  option: {
    fontSize: 16,
  },

  searchWrap: {
    // width: '30%',
    // position: 'absolute',
    // float: 'right',
    // display: 'inline-block',
    marginTop: 0,
  },
  findTerm: {
    position: 'relative',
    // marginTop: '2px',
    border: '1px solid ',
    borderColor: Colors.link,
    height: '35px',
    marginBottom: '0px',
    // marginTop: '2px',
    borderRadius: '5px',
    outline: 'none',
    fontSize: 16,
    // color: Colors.link
    paddingRight: '75px',
  },
  findOkButton: {
    ...commonFindButton,
    borderRadius: '0px 5px 5px 0px',
    right: '14px',
  },
  findClrButton: {
    ...commonFindButton,
    borderRadius: '0px',
    right: '48px',
    borderColor: Colors.mainGreen,
    background: Colors.mainGreen,
  },

  tr: {
    borderBottomWidth: 1,
    borderBottomColor: Colors.lightBorder,
    borderBottomStyle: 'solid',
  },
  th: {
    fontSize: 16,
    color: Colors.fontGrey,
    // height: 35,
    fontWeight: 'regular',
    verticalAlign: 'middle',
    wordWrap: 'break-word',
  },
  td: {
    color: Colors.softBlack,
    fontSize: 16,
    // height: 40,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    verticalAlign: 'middle',
    wordWrap: 'break-word',
  },

  itemCheckbox: {
    marginTop: 0,
    height: 40,
    width: 50,
    // transform: 'scale(1.5)'
  },
  itemChartIcon: {
    fontSize: 16,
    color: Colors.fontBlack,
    cursor: 'pointer',
  },
  button: {
    // height: 35,
    borderRadius: 5,
    fontSize: 16,
    letterSpacing: 1.5,
    fontWeight: 'bold',
    wordSpacing: 4,
    // display: 'inline-block',
    // paddingTop: 5,
    // paddingRight: 15,
    paddingBottom: 5,
    // paddingLeft: 15,
    borderWidth: 0,
    marginTop: 10,
    // marginRight: 7,
    // marginLeft: 7,
    borderStyle: 'solid',
    cursor: 'pointer',
    textAlign: 'center',
    verticalAlign: 'middle',
  },
};

export default Subscribers;
